import { createAction } from 'redux-actions'

const ns = 'signup/'

export const doSignUp = createAction(`${ns}DO_SIGN_UP`)
export const doSignUpSuccess = createAction(`${ns}DO_SIGN_UP_SUCCESS`)
export const doSignUpFail = createAction(`${ns}DO_SIGN_UP_FAIL`)
